import React from "react";
import { Button } from "nectar-ui";
import { useHistory } from "react-router-dom";
import { useAstreaUtilities } from "@context/astreaUtilities/astreaUtilitiesContext";

const LogoutButton = () => {
  const { logout } = useAstreaUtilities();
  const history = useHistory();

  const handleLogoutClick = () => {
    logout(() => {
      history.push("/login");
      window.location.reload();
    });
  };

  return (
    <Button flat block style={{ lineHeight: 1.4 }} onClick={handleLogoutClick}>
      Sair da sua conta
    </Button>
  );
};

export default LogoutButton;
